import EmptyState from "./EmptyState";
import MetadataItemRow from "./MetadataItemRow";
import { MetadataItem } from "./types";

const EditableContent = ({
  metadataArray,
  jsonToggleByIndex,
  handleInputChange,
  toggleJsonEditor,
  deleteRow,
}: {
  metadataArray: MetadataItem[];
  jsonToggleByIndex: Record<string, boolean>;
  handleInputChange: (id: string, key: string, value: string) => void;
  toggleJsonEditor: (id: string) => void;
  deleteRow: (id: string) => void;
}) => (
  <>
    {metadataArray.filter(
      item => item.key !== "markdown_enabled" && item.key !== "streaming_enabled",
    ).length ? (
      <div className="space-y-2">
        {metadataArray.map(item => (
          <MetadataItemRow
            key={item.id}
            item={item}
            isJsonMode={!!jsonToggleByIndex[item.id]}
            onKeyChange={value => handleInputChange(item.id, value, item.value)}
            onValueChange={value => handleInputChange(item.id, item.key, value)}
            onToggleJsonMode={() => toggleJsonEditor(item.id)}
            onDelete={() => deleteRow(item.id)}
          />
        ))}
      </div>
    ) : (
      <EmptyState />
    )}
  </>
);

export default EditableContent;
